import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { href: '#today', label: '今日重磅' },
  { href: '#weekly', label: '本周必看' },
  { href: '#monthly', label: '本月最劲爆' },
  { href: '#yearly', label: '年度盘点' },
  { href: '#feed', label: '全量吃瓜流' },
  { href: '#faq', label: '吃瓜百科' },
  { href: '#about', label: '关于我们' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const dateText = new Date().toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
  });

  return (
    <header className="relative z-30">
      {/* 顶部信息条 */}
      <div className="bg-foreground-950 text-background-50/90 text-xs md:text-sm">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-2 md:px-6">
          <p className="flex items-center gap-2">
            <i className="ri-flashlight-fill text-accent-400" />
            <span className="hidden sm:inline">{dateText}　今日宜：理性吃瓜 · 忌：听风是雨</span>
            <span className="sm:hidden">吃瓜编辑部 · 每日热闻</span>
          </p>
          <div className="flex items-center gap-3">
            <a href="#about" className="whitespace-nowrap hover:text-accent-300">投稿线索</a>
            <span className="h-3 w-px bg-background-50/30" />
            <a
              href="mailto:bichidagua@example.com?subject=必吃大瓜线索投稿"
              className="flex items-center gap-1 whitespace-nowrap hover:text-accent-300"
            >
              <i className="ri-mail-line" /> 联系我们
            </a>
          </div>
        </div>
      </div>

      {/* 报头 */}
      <div className="border-b border-background-200 bg-background-50">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-4 md:px-6 md:py-5">
          <a href="#top" className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 md:h-12 md:w-12">
              <i className="ri-bard-fill text-xl md:text-2xl" />
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-2xl font-black tracking-wide text-foreground-950 md:text-3xl">
                必吃大瓜
              </span>
              <span className="block text-[11px] tracking-[0.2em] text-foreground-500 md:text-xs">
                BICHIDAGUA · 编辑部号外
              </span>
            </span>
          </a>

          <div className="hidden items-center gap-4 lg:flex">
            <span className="flex items-center gap-1 rounded-full border border-accent-300 bg-accent-50 px-3 py-1.5 text-xs font-medium text-accent-700">
              <i className="ri-fire-fill" /> 今日热搜榜 实时更新
            </span>
            <a
              href="#yearly"
              className="whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              年度盘点专题
            </a>
          </div>

          {/* 移动端菜单按钮 */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-800 lg:hidden"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
          </button>
        </div>

        {/* 移动端导航 */}
        {menuOpen && (
          <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 lg:hidden">
            <div className="grid grid-cols-2 gap-2 pt-4 sm:grid-cols-3">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-center whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-500 hover:text-background-50"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>

      {/* 吸顶主导航 */}
      <nav
        className={`border-b transition-shadow ${
          scrolled
            ? 'fixed inset-x-0 top-0 border-background-200 bg-background-50/95 shadow-sm backdrop-blur'
            : 'border-background-200/60 bg-background-50'
        }`}
        aria-label="主导航"
      >
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6">
          <div className="hidden h-12 items-center gap-1 overflow-x-auto md:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="group relative whitespace-nowrap px-3 py-3.5 text-sm font-medium text-foreground-700 hover:text-primary-600"
              >
                {l.label}
                <span className="absolute inset-x-3 bottom-0 h-0.5 origin-left scale-x-0 rounded bg-primary-500 transition group-hover:scale-x-100" />
              </a>
            ))}
          </div>
          <p className="hidden text-xs font-medium tracking-wide text-foreground-500 md:flex md:items-center md:gap-2">
            <i className="ri-flag-2-line text-primary-500" /> 每天点开都有新瓜 · 不错过任何一条劲爆
          </p>
          {/* 移动端展示分类标签 */}
          <div className="flex h-11 items-center gap-2 overflow-x-auto md:hidden">
            {NAV_LINKS.slice(0, 5).map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-700"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </nav>
    </header>
  );
}